import template from './spinner.template.html';
import './spinner.scss';

export default {
  template,
  bindings: {
    size: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.js